<template>
  <v-card>
    <v-card-title>
      Businesses
      <v-spacer></v-spacer>
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-expand
          show-expand
          hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
        show-expand
        :headers="headers"
        :items="restaurants"
        item-key="createdOn"
        class="elevation-1"
        :search="search"
        :single-select="singleSelect"
        @item-expanded="getImportsByItem"
        :loading="isLoadingResturants"
        @click:row="clickRow"
        :expanded.sync="expanded"
        :sort-by="['formattedUpdatedOn']"
        :sort-desc="[true]"
    >
      <template v-slot:[`item.revelRestaurantId`]="{ item }">
        <button @click="showItemData(item)">
        {{ item.revelRestaurantId }}
        </button>
        <v-dialog
            v-model="showDialog"
            max-width="500"
            overlay-opacity="0"
            content-class="elevation-1"
        >
          <v-card>
            <v-card-title>Como Business Id:{{modalData.comoBusinessId}}, Name:{{modalData.customerName}}</v-card-title>
            <v-card-text>
              <pre>{{JSON.stringify(modalData, null, 2) }}</pre>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:[`item.configurationValidationResult`]="{ item }">
        <v-chip
            :color="getStatusColor(item.configurationValidationResult.valid)"
            dark
        >
          {{ getStatusTest(item.configurationValidationResult.valid) }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
          <v-btn v-if="!item.configurationValidationResult.valid"
              small
              class="mr-2"
              @click="() => toggleUpdateForm(item)"
          >
            Update Credentials
          </v-btn>
        <v-dialog v-if="item.comoBusinessId === businessToUpdate.comoBusinessId"
            v-model="showUpdateForm"
            max-width="500"
            overlay-opacity="0"
            content-class="elevation-1"
        >
          <v-card>
            <UpdateBusinessForm :businessData="businessToUpdate" v-on:businessUpdated="businessUpdated"/>
          </v-card>
        </v-dialog>
            <v-btn v-if="item.configurationValidationResult.valid"
                :loading="isGeneratingImportNow(item.comoBusinessId)"
                small
                class="mr-2"
                @click="() => toggleImportMembersForm(item)"
            >
              Generate Import file
            </v-btn>
        <v-dialog v-if="item.comoBusinessId === businessToUpdate.comoBusinessId"
                  v-model="showImportMembersForm"
                  max-width="500"
                  overlay-opacity="0"
                  content-class="elevation-1"
        >
          <v-card>
            <ImportMembersForm :businessData="businessToUpdate" v-on:importStarted="importStarted"/>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:expanded-item="{ item }" expand="doExpand">
        <td :colspan="headers.length +1">
          <v-data-table
            :headers="filesHistoyheaders"
            :items="item.history"
            :hide-default-footer=true
            :loading="isLoadingHistory(item.comoBusinessId)"
          >
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              :color="getResultColor(item.status)"
              dark
            >
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:[`item.urlValid`]="{ item }">
            <v-btn
              v-if="item.urlValid != null"
              icon
              small
              @click="downloadItem(item.urlValid)"
            >
              <v-icon>mdi-cloud-download</v-icon>
            </v-btn>
          </template>
            <template v-slot:[`item.urlInvalid`]="{ item }">
              <v-btn
                  v-if="item.urlInvalid != null"
                  icon
                  small
                  @click="downloadItem(item.urlInvalid)"
              >
                <v-icon>mdi-alert-box</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import revelRestaurantApi from '../api/restaurant.api'
import UpdateBusinessForm from "./UpdateBusinessForm";
import ImportMembersForm from "./ImportMembersForm";

export default {
  name: 'Businesses',
  components: {
    UpdateBusinessForm,
    ImportMembersForm
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    async refresh() {
      this.isLoadingResturants = true;
      try {
        const res = await revelRestaurantApi.list();
        this.restaurants = res.data;
      } catch (e) {
        console.log(e);
      }
      this.isLoadingResturants = false;
    },
    getStatusColor(valid) {
      return valid ? "green" : "red";
    },
    getResultColor(value) {
      if (value == 'done') {
        return 'green';
      }
      if (value == 'new' || value == 'in progress') {
        return 'orange';
      }
      return 'red'
    },
    clickRow(item) {
     // if (this.restaurantsMap.get(item.comoBusinessId).isRunning) {
        this.expanded.push(item);
     // }
    },
    getStatusTest(valid) {
      return valid ? "Good" : "BAD";
    },
    isLoadingHistory(comoBusinessId) {
      return this.restaurantsMap.get(comoBusinessId).isLoadingHistory;
    },
    isGeneratingImportNow(comoBusinessId) {
      return this.restaurantsMap.get(comoBusinessId).runningInterval != null;
    },
    showItemData(item) {
      this.modalData = item;
      this.showDialog = true;
    },
    toggleUpdateForm(businessData){
      this.businessToUpdate = businessData;
      this.showUpdateForm = true;
    },
    toggleImportMembersForm(businessData){
      this.businessToUpdate = businessData;
      this.showImportMembersForm = true;
    },
    businessUpdated(){
      this.businessToUpdate = {};
      this.showUpdateForm = false;
    },
    importStarted(business){
      this.showImportMembersForm = false;
      this.watchStatus(business);
    },
    async watchStatus(business) {
      await this.getImports(business);
      if(!business.runningInterval){
        const id = setInterval(async () => await this.watchStatus(business), 3000);
        this.$set(business, 'runningInterval', id);
      }
      if (business.history[0].id === business.downloadId && (business.history[0].status == "error" || business.history[0].status == "done")) {
        clearInterval(business.runningInterval);
        this.$set(business, 'runningInterval', null);
      }
    },
    async getImportsByItem({item}) {
      const business = this.restaurantsMap.get(item.comoBusinessId);
      await this.getImports(business);
    },
    async getImports(business) {
      this.$set(business, 'expanded', !business.expanded);
      if(business.expanded){
        this.$set(business, 'isLoadingHistory', true);
        const res = await revelRestaurantApi.getImports(business.comoBusinessId);
        this.$set(business, 'history', res.data)
        this.$set(business, 'isLoadingHistory', false)
        console.log(res);
      }
    },
    async downloadItem (resourceId) {
      try {
        const res = await revelRestaurantApi.download(resourceId);
        const blob = new Blob([res.data], {type: 'text/csv'});
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = resourceId;
        link.click();
        URL.revokeObjectURL(link.href);
      }catch (e) {
        console.log(e);
      }
    }
  },
  data() {
    return {
      showDownlodLink: false,
      isLoadingResturants: false,
      singleSelect: false,
      showDialog: false,
      businessToUpdate: {},
      showUpdateForm: false,
      showImportMembersForm: false,
      modalData: '',
      restaurants: [],
      expanded: [],
      headers: [
        {
          text: 'Revel ID',
          value: 'revelRestaurantId',
        },
        {
          text: 'Como ID',
          value: 'comoBusinessId',
        },
        {
          text: 'Como API Key',
          value: 'comoBusinessApiKey',
        }, {
          text: 'Revel API key',
          value: 'revelApiCredentials',
        }, {
          text: 'Created',
          value: 'createdOn',
        }, {
          text: 'Updated',
          value: 'formattedUpdatedOn',
        }, {
          text: 'Configuration',
          value: 'configurationValidationResult',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ],
      filesHistoyheaders: [
        {
          text: 'Started',
          align: 'center',
          value: 'createdOn',
        }, {
          text: 'Last Update',
          align: 'center',
          value: 'formattedUpdatedOn',
        },
        {
          text: '# Of Members',
          align: 'center',
          value: 'progress',
        },
        {
          text: 'Status',
          align: 'center',
          value: 'status',
        }, {
          text: 'Sanitized',
          align: 'center',
          value: 'urlValid',
        }, {
          text: 'Raw',
          align: 'center',
          value: 'urlInvalid',
        }

      ],
      search: '',

    }
  },
  computed: {
    restaurantsMap() {
      return new Map(this.restaurants.map(item => [item.comoBusinessId, item]))
    }
  }
}
</script>
